import { useState } from 'react';
import { baseAPI } from '../../../../../config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

const escapeHtml = t => t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
/** El cuerpo se escribe en texto y la ruta lo manda como HTML. */
const textoAHtml = texto =>
  texto
    .trim()
    .split(/\n{2,}/)
    .map(p => `<p>${escapeHtml(p).replace(/\n/g, '<br>')}</p>`)
    .join('');

// Modal para el formulario de enviar email
function EmailModal({ expedientId }) {
  const [isOpen, setIsOpen] = useState(false);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSendEmail = async e => {
    e.preventDefault();
    try {
      // Por la ruta del chat de email (23/10/2026, docs/contactar-deudor-ar-plan.md):
      // la de antes era solo del admin y salía por SendGrid. Esta sale por Resend
      // con el dominio de la empresa en AR, y por Gmail en recobro.
      await axios.post(
        `${baseAPI}/expedients/${expedientId}/emails/send`,
        { subject: subject.trim(), body: textoAHtml(message) },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      toast.success('Correo enviado exitosamente!');
      setMessage('');
      setSubject('');
      setIsOpen(false);
    } catch (error) {
      console.error('Error al enviar el email:', error);
      toast.error('Error al enviar el correo');
    }
  };

  return (
    <>
      <button
        className='w-full px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-100 text-sm font-medium transition-colors flex items-center justify-center gap-2'
        onClick={() => setIsOpen(true)}
      >
        <EnvelopeIcon className='w-4 h-4' />
        Email
      </button>
      {isOpen && (
        <div className='fixed z-10 inset-0 overflow-y-auto'>
          <div className='flex items-center justify-center min-h-screen px-4'>
            <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'></div>
            <div className='bg-white rounded-lg shadow-xl transform transition-all sm:max-w-lg sm:w-full'>
              <div className='p-6'>
                <h3 className='text-lg font-semibold text-gray-800 mb-4'>Enviar Email Personalizado</h3>
                <form onSubmit={handleSendEmail}>
                  <div className='mb-4'>
                    <label htmlFor='subject' className='block text-sm font-medium text-gray-700'>
                      Asunto:
                    </label>
                    <input
                      type='text'
                      id='subject'
                      value={subject}
                      onChange={e => setSubject(e.target.value)}
                      required
                      className='mt-1 w-full border-gray-300 rounded-lg p-2 shadow-sm'
                    />
                  </div>
                  <div className='mb-4'>
                    <label htmlFor='message' className='block text-sm font-medium text-gray-700'>
                      Mensaje:
                    </label>
                    <textarea
                      id='message'
                      value={message}
                      onChange={e => setMessage(e.target.value)}
                      rows='4'
                      required
                      className='mt-1 w-full border-gray-300 rounded-lg p-2 shadow-sm'
                    ></textarea>
                  </div>
                  <div className='flex justify-end space-x-2'>
                    <button
                      type='button'
                      className='text-gray-500 hover:text-gray-700'
                      onClick={() => setIsOpen(false)}
                    >
                      Cancelar
                    </button>
                    <button type='submit' className='bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg'>
                      Enviar Email
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EmailModal;
